import { render, staticRenderFns } from "./SchoolListStatusSelect.vue?vue&type=template&id=55ae3117"
import script from "./SchoolListStatusSelect.vue?vue&type=script&lang=js"
export * from "./SchoolListStatusSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports